module.exports = __webpack_public_path__ + "static/media/menu-active.5e63bb50.svg";